module.exports = __webpack_public_path__ + "img/banner2.e84ed0a9.jpg";